import React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';

import i18nArgs from './locales';

import styles from './SkipToContent.scss';

interface OwnProps {}

type CombinedProps = OwnProps & WithI18nProps;

export const TARGET_ID = 'SkipToContentTarget';

export function SkipToContentTarget() {
  return <div id={TARGET_ID} tabIndex={-1} />;
}

function SkipToContent({i18n}: CombinedProps) {
  return (
    <a href={`#${TARGET_ID}`} className={styles.SkipToContent}>
      {i18n.translate('SkipToContent.buttonText')}
    </a>
  );
}

export const SkipToContentLink = withI18n(i18nArgs)(SkipToContent);
